.list {
  color: var(--dds-color-text-body);
  margin: var(--dds-spacing-x1) 0;
  ul,
  ol {
    margin-block: var(--dds-font-paragraph-spacing-list);
  }
}

.list--inherit {
  font: inherit;
}

.list--unordered {
  --dds-list-bullet-size: 0.75em;
  --dds-list-ul-li-padding-left: var(--dds-list-bullet-size) + 0.5em;
  list-style: none;
  padding-left: calc(
    var(--dds-spacing-x2) - (var(--dds-list-ul-li-padding-left))
  );

  li {
    position: relative;

    padding-left: calc(var(--dds-list-ul-li-padding-left));

    &:before {
      content: '';
      display: inline-block;
      height: var(--dds-list-bullet-size);
      width: var(--dds-list-bullet-size);
      position: absolute;
      top: calc(
        (var(--dds-font-lineheight-x1) * 1em) / 2 -
          var(--dds-list-bullet-size) / 2
      );
      left: 0;
      background: var(--dds-color-text-body);
      mask-size: 100%;
      mask-repeat: no-repeat;
      mask-image: url('../Icon/svg/jordskifterett.svg');
    }
    ul > li:before {
      mask-image: url('../Icon/svg/lagmannsrett.svg');
    }
    ul > li > ul > li:before {
      mask-image: url('../Icon/svg/tingrett.svg');
    }
  }
}

.list--ordered {
  padding-left: var(--dds-spacing-x2);
  & > li > ol {
    list-style-type: lower-alpha;
  }
  & > li > ol > li > ol {
    list-style-type: lower-roman;
  }
}

.li {
  margin-bottom: var(--dds-font-paragraph-spacing-list);
}
